import { Link } from "react-router-dom";
import { leagues } from "@/mocks/leagues";

export default function SiteFooter() {
  const year = 2026;
  return (
    <footer className="bg-primary-950 text-primary-100 mt-auto">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center text-background-50 dark:text-foreground-950">
                <i className="ri-basketball-fill text-lg" />
              </span>
              <span className="font-heading font-semibold text-lg text-background-50">
                篮球直播
              </span>
            </div>
            <p className="text-sm text-primary-200 leading-relaxed">
              高清篮球比赛实况与赛程资讯平台，覆盖国内外各大篮球联赛，为篮球爱好者提供一站式观赛与信息体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4 tracking-wide">
              <Link to="/schedule" className="cursor-pointer hover:text-accent-400 transition-colors">
                快速导航
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {[
                { to: "/", label: "首页" },
                { to: "/schedule", label: "赛程列表" },
                { to: "/news", label: "篮球资讯" },
                { to: "/about", label: "关于我们" },
              ].map((i) => (
                <li key={i.to}>
                  <Link
                    to={i.to}
                    className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {i.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4 tracking-wide">
              <Link to="/category/nba" className="cursor-pointer hover:text-accent-400 transition-colors">
                热门联赛
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {leagues.map((l) => (
                <li key={l.slug}>
                  <Link
                    to={`/category/${l.slug}`}
                    className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {l.name} 赛事直播
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4 tracking-wide">
              服务提示
            </h4>
            <ul className="space-y-2.5 text-sm text-primary-200">
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5 text-accent-400" />
                本站直播画面为前端演示区域，真实视频线路正在接入中
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400" />
                赛程与资讯每日更新，以实际开赛时间为准
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" />
                feedback@basketball-live.demo
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-300">
            © {year} 篮球直播 Basketball Live. 保留所有权利 · 演示站点数据仅供展示
          </p>
          <p className="text-xs text-primary-300">坚持团队协作，热爱每一场比赛</p>
        </div>
      </div>
    </footer>
  );
}